//BT-115303 : Implementing search functionality for Alerts : ManasaB : 16/08/2023 - Start

import { memo } from 'react';
import { BzChip, BzCard } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import { AlertNameDetails } from '../Alerts';

const TabAlertsContent = ({ arrAlertScrips, handleOnClickScrip, scripDetails, removeScrips, addScrips, onBuySellClick, handleEditAlert, ...props }) => {

    return (
        <>
            <Container data-testid='global-search-alerts-result-element' fluid className='px-3'>
                {arrAlertScrips?.length > 0 && arrAlertScrips?.map((each, i) => (
                    <BzCard key={i} className='p-0 py-3 bdr-card-btm'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0 mb-2'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='font-medium font-size4 color-text text-uppercase cursor-pointer text-nowrap me-2'>{each?.symbol}</div>
                                            <div className='chips-wrap'>
                                                <BzChip className='exchange-chip text-uppercase me-2'>{each?.exchange}</BzChip>
                                            </div>
                                            <AlertNameDetails alertData={each} />
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-2'>
                                        <Col className='justify-content-start align-self-center'>
                                            <div className='font-regular font-size3 color-subtext cursor-pointer'>{each?.remarks}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-2'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='chips-wrap'>
                                                <BzChip className={`chips positive-chip me-2`}>{each?.status}</BzChip>
                                            </div>
                                            <div className='font-regular font-size1 color-subtext'>Created: {each?.displayCreateDate}</div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div data-testid='global-search-alerts-edit-icon' className='icon-16 icon-edit icon-dark' onClick={(e) => { e.stopPropagation(); handleEditAlert(each); }}></div>
                            </Col>
                        </Row>

                    </BzCard>
                ))}

            </Container>

        </>
    );
};

export default memo(TabAlertsContent);

//BT-115303 : Implementing search functionality for Alerts : ManasaB : 16/08/2023 - End
